// Dev-only diagnostics: silent in production builds, so recoverable failures never leak to the visitor's console.
const dev = process.env.NODE_ENV !== "production";

export const debugWarn = (...args) => { if (dev) console.warn(...args); };
export const debugError = (...args) => { if (dev) console.error(...args); };
